module.exports = function(newWidth) {
    this._sendMessage('width-update', {newWidth: newWidth})
};